module.exports = __webpack_public_path__ + "img/thechicken.d78f22eb.png";